"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceMapMode = void 0;
const tsenum_1 = require("@gradecam/tsenum");
exports.SourceMapMode = tsenum_1.MakeEnum({
    Inline: 'inline',
    Separate: 'separate'
});
